<template>
	<div>
		<b-modal :id="id"
				 modal-class="modal-img-in-top"
				 hide-footer
				 hide-header
				 size="md"
				 @hide="feedBack = {}"
				 @shown="$refs.feedback_input_name.focus()"
		>
			<div class="wrap-img">
				<img v-if="top_img == 'sad'" src="../assets/images/ducks/sad.png" alt="">
				<img v-else src="../assets/images/ducks/send.png" alt="">
			</div>
			<div class="modal-content">
				<h2 class="title">{{title}}</h2>
				<form @submit.prevent="sendFeedBack()">
					<div class="form-group wrap-input-modal">
						<input ref="feedback_input_name" v-model="feedBack.name" required type="text" class="form-control input-modal"
							   placeholder="Name">
					</div>
					<div v-if="phone" class="form-group wrap-input-modal phone-wrap" >
                        <div class="plus">+</div>
                        <input :placeholder="'123'" @input="validatePhone()" v-model="feedBack.phonePrefix" type="text" class="form-control input-modal phone-prefix">
						<input @input="validatePhone()" v-model="feedBack.phone" type="text" class="form-control input-modal"
							   :placeholder="phone">
						<span class="show-error" v-if="!validPhone && (feedBack?.phone?.length || feedBack?.phonePrefix?.length)">Numbers only</span>
					</div>
					<div class="form-group wrap-input-modal">
						<textarea v-model="feedBack.text" required type="text" class="form-control textarea-modal"
								  :placeholder="text_placeholder">
						</textarea>
					</div>
					<div class="">
						<input :disabled="!isFormValid" type="submit" class="submit-modal" value="Submit">
					</div>
				</form>
			</div>
		</b-modal>
		<Flash ref="show"/>
	</div>
</template>

<script>
	import Flash from "../components/Flash";
	import {api} from "../mixins/axios";

	export default {
		name: 'Feedback',
		components: {
			Flash
		},
		props: {
			title: String,
			api_title: String,
			id: String,
			text_placeholder: String,
			phone: String,
			top_img: String,
		},
		data() {
			return {
				feedBack: {},
				validPhone: null,
			}
		},
		methods: {
			async sendFeedBack() {
				try {
					let data = {
						title: this.api_title,
						body: `name: ${this.feedBack.name}, email: ${this.feedBack.email ?? localStorage.email}, ${this.feedBack.phone ? `phone: ${this.feedBack.phonePrefix}${this.feedBack.phone},` : ''} text: ${this.feedBack.text}`,
					}
					const response = await api.put(`/feedback/new`, data);
					if (response.data.status == 'ok') {
						this.$refs.show.showFlashSuccess('Your request has been sent');
						this.$bvModal.hide(this.id)
						this.feedBack = {}
						this.feedBack.email = localStorage.email
					}
				} catch (e) {
					this.$refs.show.showFlashError(e.response.data.msg)
					console.log(e)
				}
			},
			validatePhone(){
				let phone = this.feedBack.phone.toLowerCase().match(/^[0-9]*$/);
				let prefix = this.feedBack.phonePrefix.toLowerCase().match(/^[0-9]*$/);
				if(phone?.length && prefix?.length){
					this.validPhone = true
				} else {
					this.validPhone = false
				}
			},
		},
		computed: {
			isFormValid() {
				const {text, name, phonePrefix, phone} = this.feedBack;
				let requiredFields = [text, name];

				if (this.phone) {
					requiredFields.push(phonePrefix, phone);
				}

				if (this.phone) {
					return requiredFields.every(field => field) && this.validPhone;
				} else {
					return requiredFields.every(field => field);
				}
			},
		},
		mounted() {
			if(localStorage.email){
				this.feedBack.email = localStorage.email
			}
		}
	}
</script>

<style scoped lang="scss">
	@import "../assets/scss/modals/modal-feedback.scss";
    .phone-wrap{
        display: flex;
        align-items: center;
        gap: 10px;
        .phone-prefix{
            max-width: 70px;
        }
        .plus{
            font-size: 24px;
            height: 54px;
            display: flex;
            align-items: center;
            color: #9f9e9e;
            background: #F6F6F6;
            padding: 5px;
        }
    }
</style>
